export default {
  setCurrentQuestion (state, payload) {
    state.currentQuestion = payload
  },
  setAnswers (state, payload) {
    state.answers = payload
  },
  setQuestionFlowData (state, payload) {
    state.leadGenQuestions = payload?.questions
    state.totalSteps = payload?.total_steps
    state.propertyType = payload?.type
  },
  setOrgGuid (state, payload) {
    state.orgGuid = payload
  },
  setOrgType (state, payload) {
    state.orgType = payload
  },
  setSettings (state, payload) {
    state.settings = payload
  }
}
